import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FFF",
              d: "M11.535 17.245l-3.62 1.902c-.488.257-1.093.07-1.35-.42-.102-.194-.138-.417-.1-.634l.69-4.03c.056-.324-.051-.655-.287-.885L3.94 10.324c-.395-.385-.403-1.018-.018-1.414.154-.157.355-.26.573-.292l4.046-.587c.326-.048.607-.252.753-.548l1.81-3.666c.244-.495.843-.699 1.339-.454.197.097.356.257.454.454l1.81 3.666c.145.296.426.5.752.548l4.046.587c.547.08.926.587.846 1.134-.031.218-.134.419-.291.572l-2.928 2.854c-.236.23-.343.56-.288.885l.691 4.03c.094.544-.272 1.061-.816 1.155-.217.037-.44.002-.635-.1l-3.619-1.903c-.291-.154-.639-.154-.93 0z",
              transform: "translate(-128 -2441) translate(116 2316) translate(12 125)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }